






















import { Reports, User, Global, Props, Users } from '@/store';
import Vue from 'vue';
import Component from 'vue-class-component';
import moment from 'moment-timezone';
import DailyCommissionedTable from '@/pages/reports/components/DailyCommissionedTable.vue';
import FullViewReportBar from '@/pages/fullViewReport/components/reportBar/FullViewReportBar.vue';
import { fetchInstallationsLastMonth } from '@/store/modules/Projects';

@Component({
  components: {
    DailyCommissionedTable,
    FullViewReportBar
  }
})
class DailyCommissioned extends Vue {

  @Global.State('lang') lang;
  @Global.State('timezone') projectTimezone;
  @User.State('project') project;
  @Reports.Getter('commissioned_map') commissioned_map;
  @Props.State('list') projectProperties;
  @Users.State('list') users;
  
  loading = true;
  noData = false;
  weekly_commissioned = [];
  barData = {};

  async mounted() {
    this.loading = true;
    this.noData = false;

    await this.fetchWeeklyInstallations();

    this.loading = false;
  }

  async fetchWeeklyInstallations() {
    try {
      if (!this.project || !this.project.company || !this.project.id) {
        console.warn('Project information not available');
        this.noData = true;
        return;
      }

      // Fetch installations data from shared function
      const response = await fetchInstallationsLastMonth(this.project.company, this.project.id);

      if (!response) {
        this.noData = true;
        return;
      }

      // Process response - format: { "15/12": { "cabinet": 0, "controller": 1 }, ... }
      const dates = Object.keys(response).sort((a, b) => {
        const [dayA, monthA] = a.split('/').map(Number);
        const [dayB, monthB] = b.split('/').map(Number);
        
        // Use moment with project timezone for proper date handling
        const currentYear = moment.tz(this.projectTimezone).year();
        const currentMonth = moment.tz(this.projectTimezone).month() + 1;
        
        // If month is greater than current month, it's from previous year
        const yearA = monthA > currentMonth ? currentYear - 1 : currentYear;
        const yearB = monthB > currentMonth ? currentYear - 1 : currentYear;
        
        const dateA = moment.tz(`${yearA}-${monthA.toString().padStart(2, '0')}-${dayA.toString().padStart(2, '0')}`, this.projectTimezone);
        const dateB = moment.tz(`${yearB}-${monthB.toString().padStart(2, '0')}-${dayB.toString().padStart(2, '0')}`, this.projectTimezone);
        
        return dateA.valueOf() - dateB.valueOf();
      });

      // Get last 7 days for weekly chart
      const last7Dates = dates.slice(-7);
      const controllerCounts = last7Dates.map((date) => response[date].controller || 0);
      const cabinetCounts = last7Dates.map((date) => response[date].cabinet || 0);

      // Update bar chart data
      this.barData = {
        chart: {
          type: 'bar',
          height: 350
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '55%',
            endingShape: 'rounded'
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          show: true,
          width: 2,
          colors: ['transparent']
        },
        xaxis: {
          categories: last7Dates
        },
        yaxis: {
          labels: {
            formatter: (val) => val.toFixed(0)
          },
          decimalsInFloat: 0
        }
      };

      this.weekly_commissioned = [
        { name: 'Tondo Device', data: controllerCounts },
        { name: 'Cabinet Monitor', data: cabinetCounts }
      ];

    } catch (e) {
      console.error('[fetchWeeklyInstallations] Error:', e);
      this.noData = true;
    }
  }
}

export default DailyCommissioned;
